import { Button, Collapse, Card, message, Icon, Spin, Popconfirm, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useBoundStore } from "../../store/useBoundStore";
import { use } from "react";
import { EA, LSP, SUPER_ADMIN, TEMPLATE_BODY_COPIED, TEMPLATE_COPIED, TEMPLATE_SUBJECT_COPIED } from "../../utils/Constants";
import { DELETE_EMAIL_TEMPLATE, GET_EMAIL_TEMPLATE } from "../../utils/Api_enums";
import axios from "../../api";
import Functions from "../../Functions";

const { Panel } = Collapse;


const EmailTemplate = (props) => {
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const userInfo = useBoundStore.getState().userInfo;
  const AgencyInfo = useBoundStore.getState().AgencyInfo;
  const agencyIdEncrypted = userInfo.user_agency_assoc.length > 0 ?
    userInfo.user_agency_assoc[0].agency_id
      ? Functions.encrypt(userInfo.user_agency_assoc[0].agency_id)
      : ""
    : "";

  const userIdEncrypted = userInfo.id
    ? Functions.encrypt(userInfo.id)
    : "";

  const externalLink = `${window.location.origin}/app/create-bfile/${agencyIdEncrypted}/${userIdEncrypted}`;


  useEffect(() => {
    fetchEmailTemplates();
  }, [props.location.pathname]);


  const fetchEmailTemplates = async () => {
    setLoading(true);

    try {
      const res = await axios.get(GET_EMAIL_TEMPLATE);
      let templates = res.data.templates || [];

      // const path = props.location.pathname;
      const agencyCarrier = AgencyInfo && AgencyInfo.primary && AgencyInfo.primary.carrier;

      if (userInfo && (userInfo.user_type === EA || userInfo.user_type === LSP)) {
        templates = templates.filter((t) => {
          const carrierMatch = t.carrier_ids && t.carrier_ids.includes(agencyCarrier);
          return carrierMatch;
        });
      }

      // if (path === "/template/external-b-file-link" && userInfo && (userInfo.user_type === EA || userInfo.user_type === LSP)) {
      //   templates = templates.filter(
      //     (t) => t.external_rac_link_title && t.external_rac_link_title.trim() !== ""
      //   );
      // } else if (path === "/template/email-template" && userInfo && (userInfo.user_type === EA || userInfo.user_type === LSP)) {
      //   templates = templates.filter(
      //     (t) => !t.external_rac_link_title || t.external_rac_link_title.trim() === ""
      //   );
      // } else {
      //   templates = templates;
      // }

      // templates = templates;
      setEmailTemplates(templates);
    } catch (err) {
      console.log("Error fetching email templates:", err);
      message.error("Failed to load email templates");
    } finally {
      setLoading(false);
    }
  };



  const handleAddTemplate = () => {
    props.history.push({
      pathname: "/super-admin/add-email-template",
      state: 'Add'
    });
  };

  const handleEditTemplate = (template) => {
    props.history.push({
      pathname: "/super-admin/add-email-template",
      state: template,
    });
  };

  const handleCopyTemplateBody = (template) => {
    const html = `
    <div>
      <p>${template.body}</p>

      ${template.external_rac_link_title
        ? `
        <p>
          <a href="${externalLink}" style="text-decoration:underline;">
            ${template.external_rac_link_title}
          </a>
        </p>
        `
        : ""
      }

      <br/>

     
    </div>
  `;

    const temp = document.createElement("div");
    temp.innerHTML = html;
    temp.style.position = "fixed";
    temp.style.left = "-9999px";

    document.body.appendChild(temp);

    const range = document.createRange();
    range.selectNodeContents(temp);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand("copy");

    document.body.removeChild(temp);

    message.success(TEMPLATE_BODY_COPIED);

  };

  const handleCopyTemplateSubject = (template) => {
    const html = `
    <div>
      <p> ${template.subject}</p>
    </div>
  `;

    const temp = document.createElement("div");
    temp.innerHTML = html;
    temp.style.position = "fixed";
    temp.style.left = "-9999px";

    document.body.appendChild(temp);

    const range = document.createRange();
    range.selectNodeContents(temp);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand("copy");

    document.body.removeChild(temp);

    message.success(TEMPLATE_SUBJECT_COPIED);
  }



  const handleDeleteTemplate = async (templateId) => {
    try {
      setLoading(true);

      const response = await axios.delete(
        `${DELETE_EMAIL_TEMPLATE(templateId)}`
      );

      if (response.data.status) {
        message.success(response.data.message);
        setEmailTemplates((prev) =>
          prev.filter((t) => t.id !== templateId)
        );
      } else {
        message.error(response.data.message);
      }

    } catch (error) {
      console.error("Delete error:", error);
      message.error("Something went wrong while deleting template");

    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      {/* Header */}
      {userInfo && userInfo.user_type === SUPER_ADMIN && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 16,
          }}
        >
          <Button
            type="primary"
            onClick={handleAddTemplate}
            style={{ marginTop: "20px" }}
            className="bg-164897 borderRadius-28"
          >
            Add New Template
          </Button>
        </div>
      )}
      {/* Accordion */}

      {
        emailTemplates.length === 0 ? (
          <Card style={{ textAlign: "center", padding: "40px 0" }}>
            <div style={{ fontSize: 14, color: "#888" }}>
              {userInfo && userInfo.user_type === SUPER_ADMIN
                ? "No Templates Found. Click on Add Template to create a new template."
                : "No Templates Found."}
            </div>
          </Card>

        ) : (
          <Card>
            <Collapse accordion ghost>
              {emailTemplates.map((template) => (
                <Panel
                  key={template.id}
                  header={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: 8,
                        minWidth: 0
                      }}
                    >
                      <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis", whiteSpace: "nowrap"
                      }}>
                        {template.title}
                      </span>

                      {userInfo && userInfo.user_type === SUPER_ADMIN && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 15,
                            justifyContent: "flex-end",
                            flexShrink: 0
                          }}
                        >
                          {template.carrier_ids && template.carrier_ids.length > 0 && (
                            <Tooltip
                              overlayStyle={{ width: 180, maxWidth: 180 }}
                              title={
                                <div>
                                  {template.carrier_ids.map((carrier, i) => (
                                    <div key={i}>{carrier}</div>
                                  ))}
                                </div>
                              }
                            >
                              <Icon
                                type="info-circle"
                                style={{
                                  color: "white",
                                  fontSize: 16,
                                  cursor: "pointer",
                                  flexShrink: 0
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </Tooltip>
                          )}

                          <Popconfirm
                            title="Are you sure you want to delete this template?"
                            onConfirm={(e) => {
                              e.stopPropagation();
                              handleDeleteTemplate(template.id);
                            }}
                            onCancel={(e) => e.stopPropagation()}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Icon
                              type="delete"
                              style={{ color: "white", fontSize: 16, cursor: "pointer", flexShrink: 0 }}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </Popconfirm>
                        </div>
                      )}

                    </div>
                  }
                >

                  <p>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        <strong>Subject:</strong> {template.subject}
                      </div>
                      <div>
                        {userInfo &&
                          (userInfo.user_type === EA || userInfo.user_type === LSP) && (
                            <Button
                              type="primary"
                              onClick={() => handleCopyTemplateSubject(template)}
                              className="bg-164897 borderRadius-28"
                            >
                              <Icon type="copy" /> Copy Template Subject
                            </Button>
                          )}
                      </div>
                    </div>
                  </p>

                  <p>
                    <strong>Body:</strong>
                  </p>
                  <p>{template.body}</p>


                  {template.external_rac_link_title && (
                    <div>
                      {/* <strong>External B File Creation Link :</strong> */}
                      {" "}
                      {userInfo && userInfo.user_type !== SUPER_ADMIN ? (
                        <a
                          href={externalLink}
                          target="_blank"
                          rel="noreferrer"
                          style={{ textDecoration: "underline" }}
                        >
                          {template.external_rac_link_title}
                        </a>
                      ) : (
                        template.external_rac_link_title
                      )}
                      <br />
                    </div>
                  )}

                  <br />


                  {/* {
                    template.content_urls.length > 0 && (
                      <div>
                        <p>
                          <strong>Additional Links: </strong>
                        </p>

                        <ul>
                          {template.content_urls &&
                            template.content_urls.map((link, index) => (
                              <li key={index}>
                                <a
                                  href={link.link_url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {link.link_title}
                                </a>
                              </li>
                            ))}
                        </ul>
                      </div>
                    )
                  } */}



                  <div style={{ textAlign: "right", marginTop: 12 }}>
                    {userInfo &&
                      userInfo.user_type === SUPER_ADMIN && (
                        <Button
                          type="primary"
                          onClick={() => handleEditTemplate(template)}
                          className="bg-164897 borderRadius-28"
                        >
                          Edit Template
                        </Button>
                      )}

                    {userInfo &&
                      (userInfo.user_type === EA || userInfo.user_type === LSP) && (
                        <Button
                          type="primary"
                          onClick={() => handleCopyTemplateBody(template)}
                          className="bg-164897 borderRadius-28"
                        >
                          <Icon type="copy" /> Copy Template Body
                        </Button>
                      )}
                  </div>
                </Panel>
              ))}
            </Collapse>
          </Card>
        )
      }

      {loading && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(255,255,255,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10
        }}>
          <Spin tip="Loading ..." />
        </div>
      )}

    </div>
  );
};

export default withRouter(EmailTemplate);



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/email_template.js